
<footer class="app-footer">
  <div class="footer-content">
    <div class="copyright">
      Copyright © {{ year }} Insurance Services Office, Inc. All rights
      reserved.
    </div>
    <div class="footer-links">
     <a class="footer-link" 
          target="_blank" href="http://www.verisk.com/"
          >Corporate Home</a>
          &nbsp;|&nbsp;
          <a class="footer-link"
          target="_blank"
          href="https://www.verisk.com/privacy-trademarks-use/verisk-analytics-conditions-of-use/"
          >Conditions of Use</a
      >&nbsp;|&nbsp;
      <a class="footer-link"
        target="_blank"
        href="https://www.verisk.com/privacy-trademarks-use/"
        >Privacy</a
      >&nbsp;|&nbsp;
      <a class="footer-link"
        href="https://www.verisk.com/contact-verisk/"
        target="_blank"
        >Contact Us</a
      >
    </div>
  </div>
</footer>
